export const PAUSE_COMMON_TASK_VALUE = 1;
export const ISSUE_COMMON_TASK_VALUE = 2;
export const COACHING_COMMON_TASK_VALUE = 3;
export const UNPAUSE_COMMON_TASK_VALUE = -2;
export const LOGOFF_COMMON_TASK_VALUE = -3;
